import "./style/partenaires.css";
import axios from 'axios';
import React from "react";
import Slider from "react-slick";


const Partner = props => (
    <div>
        <img style={{ width: "100%" }} src={`${process.env.REACT_APP_SERVER}`+'/images/'+props.partner.partnerImage} alt="" />
    </div>
  )

class Partenaires extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
          Partners: []
        };
      }    
      
      componentDidMount() {
        axios.get(`${process.env.REACT_APP_SERVER}`+'/partners/')
          .then(response => {
            this.setState({ Partners: response.data })
          })
          .catch((error) => {
            console.log(error);
          })
          
      }
    
      PartnerList() {
        return this.state.Partners.map(currentPartner => {
          return <Partner partner={currentPartner} key={currentPartner._id}/>;
        })
      }
    
    render() {
      const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 2000,
        arrows: false,
        cssEase: "linear",
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false
                }
            }
        ]
    };
        return (
            <div>
                <div className="backpartenaires">
                    <div style={{ padding: "2%" }}>
                        <h2 className="titlePartenaire">nos partenaires</h2>
                    </div>
                    <div className="partenairesList">
                        <Slider {...settings}>
                            {this.PartnerList()}
                        </Slider>
                    </div>
                </div>
            </div>
        );
    }
}
export default Partenaires;



// WEBPACK FOOTER //
// ./src/home/partenaires.js